/**
 * Page <title> with the brand suffix, kept inside what Google shows in full.
 *
 * Google truncates a title at roughly 600px, about 60 characters. Appending
 * " | LetsLoop" to every article title pushed 15 of 16 articles past that
 * (70 to 106 characters, Ahrefs/crawl audit 2026-10-24), so the end of the
 * title, and the brand, was cut off in results. The suffix is a brand cue,
 * not ranking text: when it would not fit, the article title goes out alone.
 *
 * Shared by pages/BlogPostPage.tsx (client) and scripts/prerender.mjs (static
 * head, via entry-server) so the two can never disagree.
 */
export const BRAND = "LetsLoop";
export const TITLE_MAX = 60;

export function brandedTitle(title: string, max: number = TITLE_MAX): string {
  const withBrand = `${title} | ${BRAND}`;
  return withBrand.length <= max ? withBrand : title;
}
